/*
  <bp-read-more> (T1 UX 2026-10-21). Phone-only "More / Less" for long collection intros. The clamp itself is CSS
  (bp-collection-hero.liquid, only under (scripting: enabled) and max-width 749px), so the page paints clamped with no
  layout shift and shows the full text when JavaScript is off. This element only toggles it: the button's
  aria-expanded and label, and it opens by itself when keyboard focus moves onto a link inside the hidden part.
*/
class BpReadMore extends HTMLElement {
  connectedCallback() {
    this.btn = this.querySelector('.bp-chero__more');
    this.text = this.querySelector('.bp-chero__text');
    if (!this.btn || !this.text) return;
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.btn.addEventListener('click', () => this.toggle(), { signal });
    this.text.addEventListener('focusin', () => this.toggle(true), { signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  /** @param {boolean} [open] */
  toggle(open = !this.classList.contains('is-open')) {
    this.classList.toggle('is-open', open);
    this.btn.setAttribute('aria-expanded', String(open));
    this.btn.textContent = open ? this.btn.dataset.less : this.btn.dataset.more;
  }
}

if (!customElements.get('bp-read-more')) customElements.define('bp-read-more', BpReadMore);
